var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-layout',{staticClass:"row",staticStyle:{"height":"100%"}},[_c('TopBarView',{staticClass:"col-12"}),_c('router-view',{staticClass:"column col-12",staticStyle:{"min-height":"92%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }